<div class="auction-actions">
  <span [ngSwitch]="auctionStatus" *ngIf="!auctionData?.is_closed">
    <p *ngSwitchCase="'upcoming'">
      <timer [Mode]="'light'" type="date" (TimerEnded)="$event?OnReload('upcoming'):null" [time]="auctionData?.remaining_time" [startORend]="1"></timer>
    </p>
    <p *ngSwitchCase="'ongoing'">
      <timer  [class.timeExtended]="timeExtended"  (RemainingTime)="getRemaining();" *ngIf="auctionData?.end_at" (TimerEnded)="$event?OnReload('ongoing'):null" [Mode]="'light'" type="date" [time]="auctionData?.remaining_time" [auctionData]="auctionData" [startORend]="2" [getRemainingFromSocket]="1">
        <span *ngIf="timeExtended" id="timeExtended">Time Extended</span>
      </timer>
    </p>

  </span>


  <div class="joined-auction pb-4">
    <!-- 
    <div *ngIf="auctionData?.is_closed" class="winner">

      <div class="withWinner" *ngIf="auctionData?.winner">
        <div class="head">
          <h4>The auction has ended</h4>
          <p>Item sold</p>
        </div>

      </div>
      <div class="withOutwinner" *ngIf="!auctionData?.winner">
        <div class="head">
          <h4>The auction has ended</h4>
          <p>With No Winner</p>
        </div>
      </div>
    </div> -->


    <div *ngIf="auctionData?.is_closed" class="winner">

      <div class="withWinner" *ngIf="auctionData?.winner">
        <div class="head">
          <h4>{{'Auction Item.The auction has ended' | translate}}</h4>
          <p>{{'items-requests.Item sold' | translate}}</p>
        </div>
        <div class="detailes row">
          <div class="leftSide col-6">
            <span>{{'Home.Auction' | translate}} <br>{{'items-requests.Winner' | translate}}</span>
            <img src="/assets/images/icons/winnerCup.svg" alt="winnerCup">
          </div>
          <div class="rightSide d-flex col-6">
            <div class="info-badge">
              <div class="badge-img rounded-circle">
                <img *ngIf="auctionData?.winner.image" [src]="auctionData?.winner.image"
                  (error)='auctionData?.winner.image = ""'>
                <span *ngIf="!auctionData?.winner.image">
                  {{auctionData?.winner.firstname +" "+ auctionData?.winner.lastname | shortName }}</span>
              </div>
              <div class="badge-text">
                <p>{{auctionData?.winner.firstname +" "+ auctionData?.winner.lastname |titlecase}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="withOutwinner" *ngIf="!auctionData?.winner">
        <div class="head">
          <h4>{{'Auction Item.The auction has ended' | translate}}</h4>
          <p>{{'items-requests.With No Winner' | translate}}</p>
        </div>
      </div>



      <!-- <p> Winner is {{auctionData?.winner.firstname}} {{auctionData?.winner.lastname}}</p>
      <p>Auction Ended With No Winner</p> -->
    </div>



    <!-- <div class="reserve_admin" *ngIf="!auctionData?.is_closed &&
       auctionData?.is_reserve && 
       auctionData?.remaining_minutes_for_reserve && 
      auctionStatus == 'end'">

      <div class="head">
        <h4>The auction has ended</h4>
        <p>Reserve price not met</p>
      </div>
      <div class="d-flex justify-content-center align-items-center" style="background-color: #fff;">
        <div class=" auction-badge w-auto">
          <div class="badge-img rounded-circle">
            <img *ngIf="LastBidder?.image" [src]="LastBidder?.image" (error)='LastBidder.image = ""'>
            <span *ngIf="!LastBidder?.image">
              {{LastBidder?.username| shortName }}</span>
          </div>
          <div class="badge-text text-left">
            <p class="head">Top Bidder</p>
            <p class="name">{{LastBidder?.username | titlecase }} </p>
          </div>
        </div>
      </div>

    </div> -->

    <div class="wallet-current">
      <div class="current-bid current-bid-admin">
        <p class="current-bid-txt">{{auctionData?.is_closed?("Auction Item.Final Bid"|translate):("Auction Item.Current bid"|translate)}}</p>
        <p class="current-bid-price"><span>{{"Auction Item.SR"|translate}}</span>
          {{auctionData?.is_closed?auctionData?.last_bidding:number}}</p>
        <ng-container *ngIf="auctionData?.is_reserve">
          <p class="current-bid-txt current-bid-last">{{"Auction Item.Reserveprice"|translate}}</p>
          <p class="current-bid-last-price"><span>{{"Auction Item.SR"|translate}}</span> {{auctionData?.reserve_price}}
          </p>
        </ng-container>


      </div>
    </div>

    <div class="time-start-txt"
      *ngIf="(auctionStatus == 'upcoming' || auctionStatus=='ongoing') && !auctionData?.is_closed">
      <p *ngIf="auctionStatus == 'upcoming'">
        {{ "Auction Item.YouCanBegin" | translate}}
        {{startDateTimer | dateUTC}}
        <ng-container *ngIf="auctionData?.end_at">
          {{ "Auction Item.at" | translate}}
          {{endDateTimer | dateUTC:'hh:mm A'}}
        </ng-container>
      </p>
      <!-- <p *ngIf="auctionStatus == 'ongoing'">
        {{ "Auction Item.auctionHasStarted" | translate}}
        {{endDateTimer | dateUTC:'hh:mm A'}}
        {{ "Auction Item.auctionHasStartedBut" | translate}}
      </p> -->
    </div>


    <div class="action-auction">

      <!-- <ng-container *ngIf="auctionStatus == 'ongoing' && !auctionData.is_closed">
        <button mat-button class="btnLight_fill edit-action" (click)="onEndAuction()">
          {{ "Auction Item.End Auction"| translate}}
        </button>
      </ng-container> -->

      <!-- Resrve price Actions from Admin [Start] -->

      <div class="reserve_admin_actions w-100" *ngIf="auctionData?.winner && !auctionData?.delivered">
        <!-- <p class="lable">Waiting for the top bidder to increase his/her bid</p>
        <div class="timer">
          {{countdownString}} <span>left</span>
        </div>

        <h4>OR</h4> -->
        <div class="btns w-100">
          <button mat-button class="btn_fill w-100" (click)="AdminConfirmSolid()"
            [appLoading]="loadingBtnRequest">{{'Auctions.Delivered and collected' | translate}}</button>
          <!-- <button mat-button class="btnLight_fill w-100" (click)="AdminEndAuctionWithNoWinner()"
            [appLoading]="loadingBtnRequest">End auction - no
            winner</button> -->

        </div>
      </div>

      <div class="reserve_admin_actions isDelivered w-100" *ngIf="auctionData?.winner && auctionData?.delivered">
        <h5>{{'items-requests.Item is Delivered' | translate}}</h5>

        <p *ngIf="auctionData?.delivered_note">{{auctionData?.delivered_note}}</p>
        <!-- <app-files-viewer-btn
        [files]="[documentDetailsData.FileDoc]"
        [labelName]="'Word Version'"
      ></app-files-viewer-btn> -->

      <app-files-viewer *ngIf="auctionData?.delivered_file"
      [files]="[auctionData?.delivered_file]"
    ></app-files-viewer>
        <!-- <a *ngIf="auctionData?.delivered_file" [href]="'https://auctiondev.mosandah.com.sa/public/uploads/default.PNG'"
          [download]="'https://auctiondev.mosandah.com.sa/public/uploads/default.PNG'" target="_blank">Download Document <svg height="20" viewBox="0 0 20 20" width="20">
            <path
              d="M2.4,20A2.5,2.5,0,0,1,0,17.508V11.42a.294.294,0,0,1,.093-.2l3.07-5.918a.432.432,0,0,1,.419-.219H5.349a.489.489,0,0,1,0,.977H3.861L1.3,10.953h2.6A3.047,3.047,0,0,1,6.7,12.836a2.154,2.154,0,0,0,1.953,1.3h2.7a2.154,2.154,0,0,0,1.953-1.3,3.047,3.047,0,0,1,2.791-1.883h2.651L16.582,6.064h-1.93a.489.489,0,0,1,0-.977h2.233a.457.457,0,0,1,.442.244l2.6,5.893a.464.464,0,0,1,.07.2v6.088A2.5,2.5,0,0,1,17.6,20Zm7.279-8.68L6.512,7.973a.511.511,0,0,1,0-.588.453.453,0,0,1,.651-.1L9.535,9.781V.49a.466.466,0,1,1,.93,0V9.781l2.372-2.494a.446.446,0,0,1,.558,0,.507.507,0,0,1,.093.686L10.326,11.32a.284.284,0,0,1-.027.029.428.428,0,0,1-.624-.029Z"
              fill="#322075" id="download-btn" />
          </svg></a> -->

      </div>

      <!-- Resrve price Actions from Admin [End] -->

    </div>

  </div>
</div>